import { useCallback, useState } from 'react'

function useWarningDialog(onSubmit) {
  const [openDialog, setOpenDialog] = useState(false)

  const handleSubmitDialog = useCallback(
    (...args) => {
      onSubmit(...args)
      setOpenDialog(false)
    },
    [onSubmit]
  )

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return {
    openDialog,
    handleSubmitDialog,
    handleOpenDialog,
    handleCloseDialog,
  }
}

export default useWarningDialog
